var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import _, { debounce } from "lodash";
import VueDialog from "../../../interface/IVueDialog";
import BusinessGoodsPriceService from '../../../api/BusinessGoodsPriceService';
import { initClientsRight, formateClientsByGroupTree, createResultByClientsRight, fixBusinessIdsContainGroupNotHasChildren, checkedTempGroupData } from '../../../helper/businessGoodsPriceFunc';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clients = [];
        _this.clientsRight = [];
        _this.supplier_to_business_ids = [];
        _this.group_ids = [];
        _this.needCheckedIsTemp = false;
        _this.disabled = false;
        _this.descHtml = '';
        _this.requiredChooseNum = true;
        _this.leftKeyword = '';
        _this.rightKeyword = '';
        _this.rightTreeReady = false;
        _this.defaultProps = {
            label: 'business_name',
            id: "supplier_to_business_id"
        };
        _this.isSelectAll = false;
        _this.indeterminate = false;
        _this.debounceComputedSelectAll = null;
        return _this;
    }
    Dialog.prototype.created = function () {
        this.service = BusinessGoodsPriceService.getInstance();
    };
    Dialog.prototype.mounted = function () {
        this.getClients();
        this.debounceComputedSelectAll = debounce(this.updateSelectAll, 300);
    };
    Dialog.prototype.selectAll = function () {
        if (this.isSelectAll) {
            this.supplier_to_business_ids = this.$refs.tree.getCheckedKeys(true);
            this.$refs.tree.setCheckedNodes(this.clients);
        }
        else {
            this.$refs.tree.setCheckedNodes([]);
        }
    };
    Dialog.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    Dialog.prototype.filterNodeRight = function (value, data) {
        if (data.nodeType == 'business' && !data.isChk) {
            return false;
        }
        if (data.nodeType == 'business_group') {
            if (data.children.length > 0) {
                if (!data.chkChildrensNum) {
                    return false;
                }
            }
            else {
                if (data.is_set_group != 1) {
                    return false;
                }
            }
        }
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    Dialog.prototype.updateClientsRightByBusinessIds = function () {
        this.clientsRight = initClientsRight(this.clientsRight, this.supplier_to_business_ids);
        this.searchRight();
    };
    Dialog.prototype.updateClientsRightIsSetGroup = function (clientsRight, group_id, checked) {
        clientsRight.forEach(function (v) {
            if (v.group_id == group_id) {
                v.is_set_group = checked ? 1 : 2;
            }
        });
    };
    Dialog.prototype.getFlatNodes = function (list) {
        var _this = this;
        var result = [];
        list.forEach(function (item) {
            var children = item.children || [];
            if (Array.isArray(children) && children.length > 0) {
                result.push.apply(result, _this.getFlatNodes(children));
            }
            else {
                result.push(item);
            }
        });
        return result;
    };
    Dialog.prototype.updateSelectAll = function () {
        var flatNodeList = this.getFlatNodes(this.clients);
        this.isSelectAll = flatNodeList.length === this.supplier_to_business_ids.length;
        this.indeterminate = this.supplier_to_business_ids.length > 0 && flatNodeList.length !== this.supplier_to_business_ids.length;
    };
    Dialog.prototype.handleCheckChange = function (data, checked, indeterminate) {
        if (data.nodeType == 'business_group') {
            this.updateClientsRightIsSetGroup(this.clientsRight, data.group_id, checked);
        }
        this.supplier_to_business_ids = this.$refs.tree.getCheckedKeys(true);
        this.updateClientsRightByBusinessIds();
        this.debounceComputedSelectAll();
    };
    Dialog.prototype.delClient = function (node, data) {
        this.supplier_to_business_ids = this.supplier_to_business_ids.filter(function (id) {
            return id != data.supplier_to_business_id;
        });
        this.updateClientsRightByBusinessIds();
        this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
    };
    Dialog.prototype.changeRightGroupIsSetGroup = function (node, data) {
        if (data.nodeType == 'business_group' && data.children.length == 0 && data.is_set_group != 1) {
            this.supplier_to_business_ids = this.supplier_to_business_ids.filter(function (id) {
                return id != data.supplier_to_business_id;
            });
            this.updateClientsRightByBusinessIds();
            this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
        }
    };
    Dialog.prototype.clearAllClient = function (node, data) {
        this.supplier_to_business_ids = [];
        this.updateClientsRightByBusinessIds();
        this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
    };
    Dialog.prototype.getClients = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.service.getClientsByGroupTree({
                is_have_empty_group: _this.showEmpty ? 1 : 0
            }).then(function (res) {
                res.data.data = formateClientsByGroupTree(res.data.data);
                var new_data = res.data.data || [];
                new_data.sort(function (a, b) { return b.children.length - a.children.length; });
                _this.clients = new_data;
                if (_this.needCheckedIsTemp) {
                    var tempGroupData = checkedTempGroupData(_.cloneDeep(_this.clients));
                    _this.supplier_to_business_ids = tempGroupData.supplier_to_business_ids;
                    _this.group_ids = tempGroupData.group_ids;
                }
                _this.clientsRight = initClientsRight(_.cloneDeep(_this.clients), _this.supplier_to_business_ids, _this.group_ids);
                _this.supplier_to_business_ids = fixBusinessIdsContainGroupNotHasChildren(_this.clientsRight, _this.supplier_to_business_ids, _this.group_ids);
                setTimeout(function () {
                    _this.searchRight();
                    _this.rightTreeReady = true;
                    _this.debounceComputedSelectAll && _this.debounceComputedSelectAll();
                }, 300);
            });
        });
    };
    Dialog.prototype.searchRight = function () {
        this.$refs.rightTree.filter(this.rightKeyword);
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.applyData = function () {
        if (this.requiredChooseNum) {
            if (this.supplier_to_business_ids.length == 0) {
                this.$message.warning('请选择客户');
                return;
            }
        }
        var data = createResultByClientsRight(this.clientsRight);
        this.$emit("submit", data);
        this.close();
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], Dialog.prototype, "showEmpty", void 0);
    Dialog = __decorate([
        Component({
            watch: {
                leftKeyword: function (val) {
                    this.$refs.tree.filter(val);
                },
                rightKeyword: function (val) {
                    this.$refs.rightTree.filter(val);
                }
            }
        })
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
